import { KPIStrip } from './KPIStrip';
import { BreakdownPanel } from './BreakdownPanel';
import { RecentActivity } from './RecentActivity';
import { OpsPendingProposals } from './OpsPendingProposals';
import type { DashboardSummary } from '../../lib/types';

export interface OverviewPageProps {
  data?: DashboardSummary;
  slug: string;
  accent: string;
  loading?: boolean;
  error?: unknown;
}

export function OverviewPage({
  data,
  slug,
  accent,
  loading,
  error,
}: OverviewPageProps) {
  const b = data?.breakdowns;
  const isAll = slug === 'all';
  return (
    <div className="flex-1 overflow-auto p-3 sm:p-3.5 bg-bg">
      {error ? (
        <div className="mb-3 p-3 text-xs text-danger border border-danger/30 bg-dangerBg rounded-md">
          Falha ao carregar o resumo do dashboard.
        </div>
      ) : null}
      <KPIStrip data={data} accent={accent} loading={loading} />

      {b ? (
        <div className="mb-3 grid grid-cols-1 gap-3 md:grid-cols-2">
          {isAll ? (
            <BreakdownPanel title="Por cluster" items={b.byCluster} accent={accent} />
          ) : null}
          <BreakdownPanel title="Por sistema" items={b.bySystem} accent={accent} />
          <BreakdownPanel title="Por tipo" items={b.byType} accent={accent} />
          <BreakdownPanel title="Por fila" items={b.byStack} accent={accent} scroll />
        </div>
      ) : null}

      <OpsPendingProposals />

      <RecentActivity />
    </div>
  );
}

export default OverviewPage;
